// The local frontend may already be running when its .env file is created.
// Keep development requests pointed at the local API in that case.
export const API_BASE_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "development" ? "http://localhost:8000" : "");
